//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data(){
            return {
                price:2

            }
        },
//        methods:{
//
//            plus(){
//                this.$store.commit("plus",this.price)
//            },
//            minus(){
//                this.$store.commit("minus",this.price)
//            }
//
//        }

    }



// WEBPACK FOOTER //
// ./src/components/footer.vue